var n=function(n,r){var i,o=function(n){var c;n.id===r?i=n:null===(c=n.children)||void 0===c||c.forEach((function(n){o(n)}))};return o(n),i};export{n as findItem};
